exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quantity-container[data-v-50fe3e8a]{color:#62d6b6;font-size:18px}.quantity-button[data-v-50fe3e8a]{color:#62d6b6}.spacer[data-v-50fe3e8a]{width:100%}.spacer.spacer_menu_list_bottom[data-v-50fe3e8a]{height:70px}.center-text[data-v-50fe3e8a]{text-align:center}.quantity-container[data-v-50fe3e8a],.remove-container[data-v-50fe3e8a]{margin-right:0;width:80px;text-align:center}.main-header[data-v-50fe3e8a]{font-size:25px}ons-list-header[data-v-50fe3e8a]{padding:0!important}.list-modifiers[data-v-50fe3e8a]{margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50fe3e8a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/order/product.vue
// module id = mDa0
// module chunks = 0